import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { plainToClass } from 'class-transformer';
import { HttpErrorService } from '../../../services';
import { AbstractAppConfig } from '../../../../app.config';
import { CaseHistory } from '../domain';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CaseHistoryService {
  public static readonly V2_MEDIATYPE_CASE_EVENT_VIEW =
    'application/vnd.uk.gov.hmcts.ccd-data-store-api.ui-event-view.v2+json;charset=UTF-8';

  public static readonly QC_V2_MEDIATYPE_CASE_EVENT_VIEW =
    'application/vnd.app.quickcase.store.data.api.ui-event-view.v2+json;charset=UTF-8';

  constructor(private httpClient: HttpClient,
              private httpErrorService: HttpErrorService,
              private appConfig: AbstractAppConfig) {}

  get(caseId: string,
      eventId: string): Observable<CaseHistory> {

    const url = this.appConfig.getCaseHistoryUrl(caseId, eventId);

    let headers = new HttpHeaders({
      'Accept': [CaseHistoryService.V2_MEDIATYPE_CASE_EVENT_VIEW, CaseHistoryService.QC_V2_MEDIATYPE_CASE_EVENT_VIEW],
    });

    return this.httpClient
      .get<CaseHistory>(url, {headers: headers})
      .pipe(
        map((caseHistory: Object) => plainToClass(CaseHistory, caseHistory)),
        catchError(error => {
          this.httpErrorService.setError(error);
          return throwError(error);
        })
      )
  }
}
